module.exports = __webpack_public_path__ + "img/normal-status.4b22cf33.svg";